var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"text-align":"center","font-size":"40px","padding":"100px"}},[_vm._v("\n\t我是详情页 - "+_vm._s(this.$route.params['id'])+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }